var _circle, _path, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChart(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    fill: "url(#paint0_linear_932_1056)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5623 15.4166H22.4364C18.0381 15.4166 15.416 18.0387 15.416 22.437V32.5508C15.416 36.9612 18.0381 39.5833 22.4364 39.5833H32.5502C36.9485 39.5833 39.5706 36.9612 39.5706 32.5629V22.437C39.5827 18.0387 36.9606 15.4166 32.5623 15.4166ZM22.2189 34.9312C22.2189 35.4266 21.8081 35.8375 21.3127 35.8375C20.8173 35.8375 20.4064 35.4266 20.4064 34.9312V32.43C20.4064 31.9345 20.8173 31.5237 21.3127 31.5237C21.8081 31.5237 22.2189 31.9345 22.2189 32.43V34.9312ZM28.4056 34.9312C28.4056 35.4266 27.9948 35.8375 27.4993 35.8375C27.0039 35.8375 26.5931 35.4266 26.5931 34.9312V29.9166C26.5931 29.4212 27.0039 29.0104 27.4993 29.0104C27.9948 29.0104 28.4056 29.4212 28.4056 29.9166V34.9312ZM34.5923 34.9312C34.5923 35.4266 34.1814 35.8375 33.686 35.8375C33.1906 35.8375 32.7798 35.4266 32.7798 34.9312V27.4154C32.7798 26.92 33.1906 26.5091 33.686 26.5091C34.1814 26.5091 34.5923 26.92 34.5923 27.4154V34.9312ZM34.5923 23.597C34.5923 24.0925 34.1814 24.5033 33.686 24.5033C33.1906 24.5033 32.7798 24.0925 32.7798 23.597V22.425C29.6985 25.5908 25.8439 27.8262 21.5302 28.9016C21.4577 28.9258 21.3852 28.9258 21.3127 28.9258C20.9018 28.9258 20.5393 28.6479 20.4306 28.237C20.3098 27.7537 20.5998 27.2583 21.0952 27.1375C25.1673 26.1225 28.7923 23.9837 31.6681 20.9629H30.1577C29.6623 20.9629 29.2514 20.552 29.2514 20.0566C29.2514 19.5612 29.6623 19.1504 30.1577 19.1504H33.6981C33.7464 19.1504 33.7827 19.1745 33.831 19.1745C33.8914 19.1866 33.9518 19.1866 34.0123 19.2108C34.0727 19.235 34.121 19.2712 34.1814 19.3075C34.2177 19.3316 34.2539 19.3437 34.2902 19.3679C34.3023 19.38 34.3023 19.392 34.3143 19.392C34.3627 19.4404 34.3989 19.4887 34.4352 19.537C34.4714 19.5854 34.5077 19.6216 34.5198 19.67C34.5439 19.7183 34.5439 19.7666 34.556 19.827C34.5681 19.8875 34.5923 19.9479 34.5923 20.0204C34.5923 20.0325 34.6043 20.0445 34.6043 20.0566V23.597H34.5923Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_932_1056",
    x1: 3,
    y1: 46,
    x2: 38.1661,
    y2: -0.45766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.058745,
    stopColor: "#633F89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489578,
    stopColor: "#9D3EA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB3AD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF00EE",
    stopOpacity: 0.26
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChart);
export default __webpack_public_path__ + "static/media/icon_chart.8a51c25f1f44c85e6587448265407b70.svg";
export { ForwardRef as ReactComponent };